"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
// import { scale } from "../../../utils/scale";
const scale_1 = require("../../../utils/scale");
const images_1 = require("../../../assets/images");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const ModalViewImage_1 = __importDefault(require("../../../components/modal/ModalViewImage"));
const ListImage = (props) => {
    const { data, type } = props;
    const [visible, setVisible] = (0, react_1.useState)(false);
    const [index, setIndex] = (0, react_1.useState)(0);
    const [dataImage, setDataImage] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        if (data?.length > 0) {
            setDataImage(data);
        }
        else if (!data || data?.length == 0) {
            setDataImage([]);
        }
    }, [data]);
    const [originalSize, setOriginalSize] = (0, react_1.useState)({ width: 0, height: 0 });
    (0, react_1.useEffect)(() => {
        let widthView = type == 'post' ? (0, scale_1.scale)(295) : (0, scale_1.scale)(265);
        if (dataImage?.length == 1) {
            if (react_native_1.Platform.OS == 'web') {
                react_native_1.Image.getSize(dataImage[0].url, (width, height) => {
                    setOriginalSize({
                        width: widthView,
                        height: (height / width) * widthView,
                    });
                }, (_error) => { });
            }
            else {
                const getImageSize = async () => {
                    const resolvedImageSource = react_native_1.Image.resolveAssetSource(dataImage[0].url);
                    setOriginalSize({
                        width: widthView,
                        height: (resolvedImageSource.height / resolvedImageSource.width) * widthView,
                    });
                };
                getImageSize();
            }
            // Lấy kích thước ban đầu của ảnh
        }
    }, [dataImage]);
    if (dataImage?.length == 0) {
        return;
    }
    if (dataImage.length == 1) {
        return (react_1.default.createElement(react_native_1.View, { style: { marginTop: (0, scale_1.scale)(8) } },
            react_1.default.createElement(react_native_1.Pressable, { onPress: () => {
                    setVisible(true), setIndex(0);
                } },
                react_1.default.createElement(react_native_1.Image, { source: dataImage[0].url, style: {
                        width: originalSize.width,
                        height: originalSize.height,
                        borderRadius: (0, scale_1.scale)(8),
                        overflow: 'hidden',
                    } })),
            react_1.default.createElement(ModalViewImage_1.default, { visible: visible, onClose: () => setVisible(false), data: data, index: index })));
    }
    if (dataImage.length > 1) {
        const dataImageShow = dataImage.length > 4 ? dataImage.slice(0, 4) : dataImage;
        return (react_1.default.createElement(react_native_1.View, { style: {
                width: type == 'post' ? (0, scale_1.scale)(295) : type == 'QuoteTweet' ? (0, scale_1.scale)(267) : (0, scale_1.scale)(310),
                flexWrap: 'wrap',
                flexDirection: 'row',
            } },
            dataImageShow?.map((item, index) => {
                return (react_1.default.createElement(react_native_1.Pressable, { key: index, disabled: !item.url, onPress: () => {
                        setVisible(true), setIndex(index);
                    } },
                    react_1.default.createElement(react_native_1.Image, { source: item.url ? item.url : images_1.images?.NoImages, style: {
                            height: type == 'post'
                                ? (0, scale_1.scale)(145)
                                : type == 'QuoteTweet'
                                    ? (0, scale_1.scale)(130)
                                    : (0, scale_1.scale)(150),
                            width: type == 'post'
                                ? (0, scale_1.scale)(145)
                                : type == 'QuoteTweet'
                                    ? (0, scale_1.scale)(130)
                                    : (0, scale_1.scale)(150),
                            borderRadius: (0, scale_1.scale)(8),
                            overflow: 'hidden',
                            marginLeft: type == 'QuoteTweetDetail' ? (0, scale_1.scale)(4) : (0, scale_1.scale)(2),
                            marginBottom: type == 'QuoteTweetDetail' ? (0, scale_1.scale)(4) : (0, scale_1.scale)(2),
                        } })));
            }),
            dataImage.length > 4 && (react_1.default.createElement(react_native_1.View, { style: { width: '100%', alignItems: 'flex-end', marginTop: (0, scale_1.scale)(8) } },
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(11),
                        color: '#7C7C7C',
                        lineHeight: (0, scale_1.moderateScale)(19),
                    } }, `その他${dataImage.length - 4}枚`))),
            react_1.default.createElement(ModalViewImage_1.default, { visible: visible, onClose: () => setVisible(false), data: data, index: index })));
    }
};
exports.default = ListImage;
